/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchBalesForProcessedQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type SearchBalesForProcessedQuery = { __typename?: 'Query', trackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, intendedMaterial?: Types.MaterialType | null, status?: Types.AssetStatus | null, shouldConfirmMaterial: boolean } | null> | null };

export type ProcessBalesMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.FacilityBaleProcessedInput>;
}>;


export type ProcessBalesMutation = { __typename?: 'Mutation', facilityBaleProcessed?: Array<{ __typename?: 'ScanEvent', id: string } | null> | null };


export const SearchBalesForProcessedDocument = gql`
    query SearchBalesForProcessed($filter: TrackableAssetsListFilter) {
  trackableAssets(filter: $filter) {
    id
    assetType
    intendedMaterial
    status
    shouldConfirmMaterial
  }
}
    `;

/**
 * __useSearchBalesForProcessedQuery__
 *
 * To run a query within a React component, call `useSearchBalesForProcessedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBalesForProcessedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBalesForProcessedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchBalesForProcessedQuery(baseOptions?: Apollo.QueryHookOptions<SearchBalesForProcessedQuery, SearchBalesForProcessedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBalesForProcessedQuery, SearchBalesForProcessedQueryVariables>(SearchBalesForProcessedDocument, options);
      }
export function useSearchBalesForProcessedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBalesForProcessedQuery, SearchBalesForProcessedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBalesForProcessedQuery, SearchBalesForProcessedQueryVariables>(SearchBalesForProcessedDocument, options);
        }
export function useSearchBalesForProcessedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBalesForProcessedQuery, SearchBalesForProcessedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBalesForProcessedQuery, SearchBalesForProcessedQueryVariables>(SearchBalesForProcessedDocument, options);
        }
export type SearchBalesForProcessedQueryHookResult = ReturnType<typeof useSearchBalesForProcessedQuery>;
export type SearchBalesForProcessedLazyQueryHookResult = ReturnType<typeof useSearchBalesForProcessedLazyQuery>;
export type SearchBalesForProcessedSuspenseQueryHookResult = ReturnType<typeof useSearchBalesForProcessedSuspenseQuery>;
export type SearchBalesForProcessedQueryResult = Apollo.QueryResult<SearchBalesForProcessedQuery, SearchBalesForProcessedQueryVariables>;
export const ProcessBalesDocument = gql`
    mutation ProcessBales($input: FacilityBaleProcessedInput) {
  facilityBaleProcessed(input: $input) {
    id
  }
}
    `;
export type ProcessBalesMutationFn = Apollo.MutationFunction<ProcessBalesMutation, ProcessBalesMutationVariables>;

/**
 * __useProcessBalesMutation__
 *
 * To run a mutation, you first call `useProcessBalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessBalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processBalesMutation, { data, loading, error }] = useProcessBalesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessBalesMutation(baseOptions?: Apollo.MutationHookOptions<ProcessBalesMutation, ProcessBalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessBalesMutation, ProcessBalesMutationVariables>(ProcessBalesDocument, options);
      }
export type ProcessBalesMutationHookResult = ReturnType<typeof useProcessBalesMutation>;
export type ProcessBalesMutationResult = Apollo.MutationResult<ProcessBalesMutation>;
export type ProcessBalesMutationOptions = Apollo.BaseMutationOptions<ProcessBalesMutation, ProcessBalesMutationVariables>;